var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-header header-filter"},[_c('div',{staticClass:"page-header-image screen-container"}),_c('div',{staticClass:"login-container",class:_vm.type == 'home' ? 'pt-0 pb-0' : ''},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }